import { CSSProperties } from 'react'

const styles: {
  bar: CSSProperties
  row: CSSProperties
  toggleButton: CSSProperties
  streamPicker: CSSProperties
  shareButton: CSSProperties
  shareButtonActive: CSSProperties
} = {
  bar: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#4d4d4d',
    opacity: 0.6,
    zIndex: 1,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    height: 50,
  },
  toggleButton: {
    transition: 'transform 0.3s ease',
    cursor: 'pointer',
    margin: 4,
  },
  streamPicker: {
    margin: 8,
    padding: '4px 8px',
    backgroundColor: '#333333',
    color: '#ffffff',
    border: '1px solid #666666',
    borderRadius: 4,
    fontSize: 14,
    maxWidth: 220,
  },
  shareButton: {
    margin: 8,
    padding: '4px 10px',
    backgroundColor: '#333333',
    color: '#ffffff',
    border: '1px solid #666666',
    borderRadius: 4,
    fontSize: 14,
  },
  shareButtonActive: {
    backgroundColor: '#e05d5d',
    borderColor: '#e05d5d',
  },
}

export default styles
